export default __webpack_public_path__ + "static/status.replit.com-04ceae88e2dd702e4193a81c355a33db.webp";